import { atom } from 'jotai'
import { atomFamily } from 'jotai-family'

import type { ChartSymbolIdentity } from '@/lib/tradingview/chart-symbol-identity'

/** How a compared symbol lands on the chart. The TV chart mirrors TradingView's own
 *  compare dialog: a `Compare` study on the main % scale, or an `Overlay` study on its
 *  own price scale / in its own pane. The Percept chart draws TitanCharts' Ghost Line
 *  on the main price scale, optionally with a linked Price Spread pane below.
 *  Each engine maps the other's modes onto its closest own one (a page can mix both). */
export type ChartCompareMode = 'percent' | 'new-scale' | 'new-pane' | 'ghost' | 'ghost-spread'

export const TV_COMPARE_MODES: ChartCompareMode[] = ['percent', 'new-scale', 'new-pane']
export const PERCEPT_COMPARE_MODES: ChartCompareMode[] = ['ghost', 'ghost-spread']

export interface ChartCompareCommand {
  requestId: number
  symbols: ChartSymbolIdentity[]
  targetChartIds: string[]
  /** Absent on commands from older call sites — treated as 'percent'. */
  mode?: ChartCompareMode
}

export interface ChartCompareResult {
  created: number
  skipped: number
  failed: number
}

export const chartCompareCommandsAtomFamily = atomFamily((_pageId: string) =>
  atom<Record<string, ChartCompareCommand | undefined>>({})
)

export const chartCompareTargetsAtomFamily = atomFamily((_pageId: string) =>
  atom<Record<string, string[] | undefined>>({})
)

export const chartCompareResultsAtomFamily = atomFamily((_pageId: string) =>
  atom<Record<number, Record<string, ChartCompareResult>>>({})
)
